export const TEAMS_SUCCESS = 'TEAMS_SUCCESS';
export const TEAMS_UPDATE_STATUS = 'TEAMS_UPDATE_STATUS';
export const TEAMS_ERROR = 'TEAMS_ERROR';
export const TEAMS_LOADING = 'TEAMS_LOADING';
export const RESET_STATE = 'RESET_STATE';